document.addEventListener('click', (event) => {
	const swatch = event.target.closest('.ll-collection-card__swatch');
	if (!swatch) return;

	const card = swatch.closest('[data-ll-product-card]');
	if (!card) return;

	card.querySelectorAll('.ll-collection-card__swatch').forEach((item) => {
		const selected = item === swatch;
		item.classList.toggle('is-selected', selected);
		item.setAttribute('aria-pressed', String(selected));
	});

	const variantUrl = swatch.dataset.variantUrl;
	if (variantUrl) {
		card.querySelectorAll('[data-ll-product-link]').forEach((link) => {
			link.href = variantUrl;
		});
	}

	const variantImage = swatch.dataset.variantImage;
	const image = card.querySelector('.ll-collection-card__image');
	if (variantImage && image) {
		image.style.opacity = '0';
		window.setTimeout(() => {
			image.src = variantImage;
			image.srcset = '';
			image.style.opacity = '1';
		}, 120);
	}
});
